import { useQuery } from '@tanstack/react-query'
import { liveCheckinLevelsService } from '../../services/lives-checkins-levels'

export const LEVELS_KEY = 'getLiveCheckinLevels'

export function useGetLevels() {
  const { data, isLoading } = useQuery({
    queryKey: [LEVELS_KEY],
    queryFn: () =>
      liveCheckinLevelsService.getList({
        take: 100,
        active: true,
        deleted: false,
      }),
  })

  return {
    levels: data?.data ?? [],
    isLoading,
  }
}
